import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UserService } from '../../secure/admin/manage-users/shared/user.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BrandingService } from '../../../core/services/branding.service';
import { AdminEmails } from '../../../shared/components/filter-menu/models/admin-emails';
import { AuthService } from '../../../core/services/auth.service';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  @ViewChild('UsernameOrEmail') usernameCtrl: FormControl;

  usernameOrEmail: string;
  adminEmails: AdminEmails;

  get logoPath(): string {
    return this.brandingService.getLogoPath();
  }

  constructor(
    private userService: UserService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private brandingService: BrandingService,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {}

  resetPassword(): void {
    this.userService.resetPassword(this.usernameOrEmail).subscribe(
      response => {
        this.translateService
          .get('RESET-PASSWORD.RESET-SUCCESS-MESSAGE')
          .toPromise()
          .then(t => this.toastrService.success(t));
        this.resetInputData();
      },
      errorObject => {
        if (errorObject.error === 'RESET-PASSWORD.USER-BLOCKED') {
          this.getAdminEmails();
        } else {
          this.translateService
            .get('RESET-PASSWORD.RESET-SUCCESS-MESSAGE')
            .toPromise()
            .then(t => this.toastrService.success(t));
        }
        this.resetInputData();
      },
    );
  }
  public getAdminEmails(): void {
    this.adminEmails = new AdminEmails();
    this.authService
      .getUserAdminsEmails(this.usernameOrEmail)
      .subscribe(emails => {
        this.adminEmails = emails;
        this.cd.markForCheck();
      });
  }
  private resetInputData(): void {
    this.usernameCtrl.reset();
    this.cd.markForCheck();
  }
}
